import React from 'react';

export default function Banner({ bgUrl, imgUrl, title, subTitle }) {
  return (
    <div className="max-w-[1200px] mx-auto px-6 md:px-16 my-16 md:my-24">
      <div 
        className="relative rounded-md overflow-hidden bg-cream-dark px-6 py-12 md:p-20 text-center flex flex-col items-center justify-center md:min-h-[400px]" 
        style={{ backgroundImage: `url(${bgUrl})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        <div className="absolute inset-0 bg-crimson/90"></div>
        {imgUrl && <img src={imgUrl} alt="Banner" className="w-14 h-14 md:w-16 md:h-16 object-contain mb-6 md:mb-8 relative z-10 brightness-0 invert opacity-90" />}
        <h2 className="font-serif text-[2rem] md:text-[3.5rem] font-light leading-tight text-white mb-4 md:mb-6 relative z-10 max-w-[800px]">{title}</h2>
        <p className="text-base md:text-xl text-white/80 font-light m-0 relative z-10 max-w-[600px] leading-relaxed">{subTitle}</p>
      </div>
    </div>
  );
}
